<template>
    <router-view :key="$route.name"></router-view>
</template>

<script>
export default {
    name: "jwb.vue",

}
</script>

<style scoped>

</style>
